import React from 'react';
import styled, { css } from 'styled-components';
import {
  brandColours,
  fontSize,
  minBreakpointQuery,
  sectionMargins,
  standardColours,
} from '../styles';
import { Container } from './ui';

const StyledQuote = styled.section`
  ${({ isBlogDetail }) => {
    if (isBlogDetail) {
      return css`
        ${sectionMargins('20px', '40px')};
      `;
    } else {
      return css`
        ${sectionMargins()};
      `;
    }
  }}
`;

const StyledFigure = styled.figure`
  margin: 0;

  ${minBreakpointQuery.small` 
    margin-left: 20px;
  `}

  ${minBreakpointQuery.smedium`
    margin-left: 40px;
  `} 

  ${minBreakpointQuery.medium`
    margin-left: 60px;
  `} 

  ${minBreakpointQuery.large`
    margin-left: 80px;
  `} 
  
  ${minBreakpointQuery.xlarge`
     margin-left: 100px;
  `};
`;

const StyledBlockquote = styled.blockquote`
  margin: 0;
`;

const StyledText = styled.p`
  ${fontSize(20)};
  line-height: 1.5;
  color: ${brandColours.primary};

  ${minBreakpointQuery.small`
    ${fontSize(22)};
  `}

  ${minBreakpointQuery.medium`
    ${fontSize(26)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(30)};
  `}
`;

const StyledAuthor = styled.figcaption`
  margin-top: 20px;
  display: flex;
  align-items: center;

  ${minBreakpointQuery.small`
    ${fontSize(18)};
    margin-top: 30px;
  `}

  ${minBreakpointQuery.medium`
    margin-top: 40px;
  `}

  ${minBreakpointQuery.large`
    ${fontSize(20)};
    margin-top: 50px;
  `}

  &:before {
    content: '';
    display: inline-block;
    background: ${standardColours.black};
    height: 2px;
    width: 24px;
    margin-right: 12px;

    ${minBreakpointQuery.small`
      margin-right: 14px;
    `}

    ${minBreakpointQuery.large`
      margin-right: 16px;
    `}
  }
`;

const Quote = ({ author, quote, isBlogDetail }) => (
  <StyledQuote isBlogDetail={isBlogDetail}>
    <Container narrow={isBlogDetail}>
      <StyledFigure>
        <StyledBlockquote>
          <StyledText>{quote}</StyledText>
        </StyledBlockquote>
        {author && <StyledAuthor>{author}</StyledAuthor>}
      </StyledFigure>
    </Container>
  </StyledQuote>
);

export default Quote;
